import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Button, CircularProgress, Grid, Typography } from '@mui/material';
import { log, req } from "../../utils";
import { useDataContext } from '../../contexts/DataContext';
import { CompleteJob } from './CompleteJob';

const normalizeJobStatus = (status) => (status || '').trim().toLowerCase();

const primaryActionSxDefault = {
    minHeight: 48,
    fontSize: '1rem',
    fontWeight: 600,
    textTransform: 'none',
};

export function JobProgress({ jobStatus, job, primaryButtonSx = primaryActionSxDefault }) {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const { service_call_id } = useParams();
    const { updateProperty } = useDataContext();

    const handleOnClick = async (value) => {
        setIsSubmitting(true);
        const currentUnixTimestamp = Math.floor(new Date().getTime() / 1000);
        const postData = {
            service_call_id: service_call_id,
            status: value,
            log_time: currentUnixTimestamp,
        };

        try {
            const response = await req("POST", "change_status", postData);
            if (!response) {
                alert('Could not update job status. Please try again when back online.');
                return;
            }
            updateProperty('job', service_call_id, 'status', value);
        } catch (error) {
            log("job_status_update_exception", error);
            alert("Could not update job status. Please try again.");
        } finally {
            setIsSubmitting(false);
        }
    };

    const renderButton = (text, value) => {
        if (value === 'COMPLETED') {
            return <CompleteJob job={job} primaryButtonSx={primaryButtonSx} />;
        }
        return (
            <Button
                variant="contained"
                size="large"
                className={isSubmitting ? 'btn-submit btn-persiangreen-hover' : 'btn-submit'}
                color="persiangreen"
                sx={{ width: '100%', ...primaryButtonSx }}
                disabled={isSubmitting}
                onClick={() => handleOnClick(value)}
            >
                {isSubmitting ? `${text}ing` : text}
                {isSubmitting && <CircularProgress size={16} style={{ marginLeft: '.5rem', marginTop: "-4px" }} />}
            </Button>
        );
    };

    const status = normalizeJobStatus(jobStatus);

    return (
        <div className='job-progress-actions text-center'>
            {status === 'not started' || status === 'scheduled' ? (
                renderButton('In Transit', 'IN TRANSIT')
            ) : status === 'in transit' ? (
                renderButton('Start Job', 'IN PROGRESS')
            ) : status === 'in progress' ? (
                renderButton('Complete Job', 'COMPLETED')
            ) : status === 'completed' ? (
                <Typography variant="subtitle1" sx={{ fontWeight: 600, color: 'persiangreen.main', py: 0.5 }}>
                    Job completed
                </Typography>
            ) : status === 'cancelled' ? (
                <Typography variant="subtitle1" sx={{ fontWeight: 600, color: 'text.secondary', py: 0.5 }}>
                    Job cancelled
                </Typography>
            ) : (
                <Grid container spacing={1}>
                    <Grid item xs={12}>{renderButton('In Transit', 'IN TRANSIT')}</Grid>
                    <Grid item xs={6}>{renderButton('Start Job', 'IN PROGRESS')}</Grid>
                    <Grid item xs={6}>{renderButton('Complete Job', 'COMPLETED')}</Grid>
                </Grid>
            )}
        </div>
    );
}
